var LGFG = LGFG || {};
LGFG.CP = LGFG.CP || {};

LGFG.CP.Map = LGFG.CP.Map || (function () {

    var _settings = {
        mapElementId: null,
        mapConfigurationEndpoint: null,
        mapMarkerEndpoint: null,
        mapMarkerInfoWindowEndpoint: null,
        mapMarkerListViewElementSelector: null,
        mapMarkerListViewEndpoint: null,
        mapMarkerListViewBeforeLoad: function () { },
        mapMarkerListViewAfterLoad: function () { },
        filterReloadsMapMarkers: null,
        filterPreventsMapMoveReload: null,
        minZoomForListResults: null,
        mapConfig: {
            country: null,
            center: {
                lat: null,
                lng: null
            },
            neBound: {
                lat: null,
                lng: null
            },
            swBound: {
                lat: null,
                lng: null
            },
            pageSize: 0,
            pageIndex: 0
        }
    };

    var _filterConfig = {
        filter: undefined,
        filterSettings: undefined
    };

    var _disableMapMoved = false;
    var _mapObject = null;
    var _markerCluster = null;
    var _markers = [];
    var _infoWindows = [];

    var clearMarkers = function (itemIds) {
        _markers.map(function (marker) {
            if (!itemIds.includes(marker.itemId)) {
                //marker.setMap(null);
            }
        });
    };

    var _getMapConfig = function () {
        return _settings.mapConfig;
    };

    var _buildListViewData = function (pageSizeOverride = undefined) {
        var result = {};
        result.mapConfig = $.extend(true, {}, _getMapConfig());
        if (typeof (pageSizeOverride) !== 'undefined') {
            result.mapConfig.pageSize = pageSizeOverride;
        }
        if (typeof (_filterConfig.filter) !== 'undefined') {
            result.mapFilter = _filterConfig.filter.getData();
        }
        return result;
    };

    var _showEmpty = function (message) {
        $(_settings.mapMarkerListViewElementSelector)
            .empty()
            .append('<div class="item">' + message + '</div>');
        if (typeof (_settings.mapMarkerListViewAfterLoad) !== 'undefined') {
            _settings.mapMarkerListViewAfterLoad();
        }
    }

    var mapMoved = function () {
        var currentCenter = _mapObject.getCenter();
        var currentNe = _mapObject.getBounds().getNorthEast();
        var currentSw = _mapObject.getBounds().getSouthWest();

        _settings.mapConfig.center.lat = currentCenter.lat();
        _settings.mapConfig.center.lng = currentCenter.lng();
        _settings.mapConfig.neBound.lat = currentNe.lat();
        _settings.mapConfig.neBound.lng = currentNe.lng();
        _settings.mapConfig.swBound.lat = currentSw.lat();
        _settings.mapConfig.swBound.lng = currentSw.lng();

        if (_settings.mapMarkerListViewElementSelector !== null && _settings.mapMarkerListViewEndpoint !== null) {

            if (typeof (_settings.mapMarkerListViewBeforeLoad) !== 'undefined') {
                _settings.mapMarkerListViewBeforeLoad();
            }

            if (_settings.minZoomForListResults === 0 || _mapObject.getZoom() > _settings.minZoomForListResults) {
                var data = _buildListViewData();
                LGFG.CP.LoadingOverlay.add('mapmarkerlistview');

                let hostname = location.hostname.split('.');
                let areaCode = 'au';
                areaCode = hostname[hostname.length - 1];

                data.culture = areaCode;

                $.ajax({
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    type: 'POST',
                    dataType: 'html',
                    data: JSON.stringify(data),
                    url : _settings.mapMarkerListViewEndpoint,
                    success : function (result) {
                        // $(_settings.mapMarkerListViewElementSelector).load(result);
                        $(_settings.mapMarkerListViewElementSelector)
                            .html(result);
                        LGFG.CP.LoadingOverlay.remove('mapmarkerlistview');
                        var totalResults = parseInt($('[data-total-results]').data('total-results'));
                        if (totalResults === 0) {
                            _showEmpty('Sorry, we couldn\'t find any results with your search terms. Please refine your query and try again.');
                            return;
                        }
                        $(_settings.mapMarkerListViewElementSelector)
                            .find('[data-map-marker-item-id]')
                            .each(function (i, e) {
                                var $listItem = $(this);
                                var itemId = $listItem.data('map-marker-item-id');
                                var itemMarker = null;
                                for (var i = 0; i < _markers.length; i++) {
                                    if (_markers[i].itemId === itemId) {
                                        itemMarker = _markers[i];
                                        break;
                                    }
                                }
                                $listItem
                                    .click(function (e) {
                                        e.preventDefault();
                                        google.maps.event.trigger(itemMarker, 'click');
                                        mapMoved();
                                    })
                                    .hover(function (e) {
                                        _showInfoWindow(itemMarker, 'hover');
                                    }, function (e) {
                                        _hideInfoWindow(itemMarker);
                                    });
                            });
                        $(_settings.mapMarkerListViewElementSelector)
                            .find('[data-next-page-index]')
                            .click(function (e) {
                                e.preventDefault();
                                var $this = $(this);
                                _settings.mapConfig.pageIndex = parseInt($this.data('next-page-index'));
                                mapMoved();
                            });
                        $(_settings.mapMarkerListViewElementSelector)
                            .find('[data-prev-page-index]')
                            .click(function (e) {
                                e.preventDefault();
                                var $this = $(this);
                                _settings.mapConfig.pageIndex = parseInt($this.data('prev-page-index'));
                                mapMoved();
                            });
                        var currentPageIndex = parseInt($(_settings.mapMarkerListViewElementSelector).find('[data-current-page-index]').data('current-page-index'));
                        var lastPageIndex = parseInt($(_settings.mapMarkerListViewElementSelector).find('[data-last-page-index]').data('last-page-index'));
                        if (currentPageIndex > lastPageIndex) {
                            _settings.mapConfig.pageIndex = lastPageIndex;
                            mapMoved();
                        }
                        if (typeof (_settings.mapMarkerListViewAfterLoad) !== 'undefined') {
                            _settings.mapMarkerListViewAfterLoad();
                        }
                            
                    }

                });

            } else {
                _showEmpty('Too many results. Please narrow your search by refining your search terms or zooming in.');
            }
        }
        if (_settings.filterReloadsMapMarkers) {
            //loadMarkers();
        }
        loadMarkers();
    };

    var _findExistingMarker = function (itemId) {
        var foundMarker = null;
        $.each(_markers, function (i, marker) {
            if (marker.itemId === itemId) {
                foundMarker = marker;
            }
        });
        return foundMarker;
    };

    var _hideInfoWindow = function (marker = undefined, hideAllButThis = false) {
        if (typeof (marker) === 'undefined') {
            _infoWindows.map(function (iw) {
                iw.src = null;
                iw.close();
            });
        } else {
            if (hideAllButThis) {
                _infoWindows
                    .filter(x => { return x.itemId !== marker.itemId })
                    .map(function (iw) {
                        iw.src = null;
                        iw.close();
                    });
            } else {
                var iw = _infoWindows[marker.itemId];
                if (typeof (iw) !== 'undefined' && iw.src !== 'click') {
                    iw.src = null;
                    iw.close();
                }
            }
        }
    }

    var _showInfoWindow = function (marker, src) {
        var iw = _infoWindows[marker.itemId];
        if (typeof (iw) === 'undefined') {
            _infoWindows[marker.itemId] = 'loading';
            $.ajax({
                url: _settings.mapMarkerInfoWindowEndpoint + '/' + marker.itemId,
                success: function (infowWindowHtml) {
                    iw = new google.maps.InfoWindow({ pixelOffset: new google.maps.Size(0, -50), disableAutoPan: true });
                    iw.setPosition(marker.position);
                    iw.setContent(infowWindowHtml);
                    _infoWindows[marker.itemId] = iw;
                    _showInfoWindow(marker, src);
                }
            });
        } else {
            if (iw !== 'loading') {
                iw.open(_mapObject);
                if (iw.src !== 'click') {
                    iw.src = src;
                }
                if (src === 'click') {
                    _disableMapMoved = true;
                    if (_mapObject.getZoom() < 12) {
                        _mapObject.setZoom(12);
                    }
                    _mapObject.panTo(marker.position);
                    //_mapObject.addListener('idle', mapMoved);
                    _renderMarkers();
                    mapMoved();
                }
            }
        }
    }

    var _renderMarkers = function (itemIds = undefined) {
        if (typeof (itemIds) === 'undefined') {
            itemIds = _markerCluster.getMarkers().map(function (existingMarker) { return existingMarker.itemId; });
        }
        _markers.map(function (marker, i) {
            google.maps.event.clearListeners(marker, 'click');
            if (itemIds.includes(marker.itemId)) {
                if (_settings.mapMarkerInfoWindowEndpoint !== null) {
                    marker.addListener('click', function () {
                        _hideInfoWindow(marker, true);
                        _showInfoWindow(marker, 'click');
                        mapMoved();
                    });
                }
                //marker.setMap(_mapObject);
                marker.shown = true;
            }
            else {
                //arker.setMap(null);
                marker.shown = false;
            }
        });
        // Add a marker clusterer to manage the markers.
        if (_markerCluster !== null) {
            if (_settings.filterReloadsMapMarkers) {
                var existingMarkerIds = _markerCluster.getMarkers().map(function (existingMarker) { return existingMarker.itemId; });
                _markerCluster.removeMarkers(_markers.filter(x => { return !x.shown; }));
                _markerCluster.addMarkers(_markers.filter(x => { return !existingMarkerIds.includes(x.itemId) && x.shown; }));
            } else {
                var existingMarkerIds = _markerCluster.getMarkers().map(function (existingMarker) { return existingMarker.itemId; });
                _markerCluster.addMarkers(_markers.filter(x => { return !existingMarkerIds.includes(x.itemId); }));
            }
        } else {
            // Initialise if not already
            _markerCluster = new MarkerClusterer(_mapObject, _markers,
                {
                    imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m',
                    maxZoom: 11
                });
        }
    };

    var loadMarkers = function () {
        if (_settings.filterPreventsMapMoveReload && _markerCluster !== null) {
            _renderMarkers();
        } else {
            if (_settings.mapMarkerEndpoint !== null) {
                var data = _buildListViewData(0);
                let hostname = location.hostname.split('.');
                let areaCode = 'au';
                areaCode = hostname[hostname.length - 1];
                const mapData = {
                    "mapConfig" : data.mapConfig,
                    "mapFilter" : data.mapFilter,
                    "culture": areaCode
                }
                LGFG.CP.LoadingOverlay.add('mapmarkers');
                $.ajax({
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    type: 'POST',
                    url: _settings.mapMarkerEndpoint,
                    data: JSON.stringify(mapData),
                    success: function (result) {
                        var markerDtos = JSON.parse(result);
                        var itemIds = markerDtos.Data.map(function (markerDto) { return markerDto.itemId; });

                        markerDtos.Data.map(function (markerDto, i) {
                            var marker = _findExistingMarker(markerDto.itemId);
                            if (marker === null) {
                                marker = new google.maps.Marker({
                                    position: { lat: markerDto.lat, lng: markerDto.lng },
                                    itemId: markerDto.itemId
                                });
                                _markers.push(marker);
                            }
                        });
                        _renderMarkers(itemIds);
                        LGFG.CP.LoadingOverlay.remove('mapmarkers');
                    }
                });
            }
        }
    };

    var initMap = function () {
        var center = new google.maps.LatLng(
            _settings.mapConfig.center.lat,
            _settings.mapConfig.center.lng
        );
        var bounds;
        if (_mapObject !== null && typeof (_mapObject.customcircle) !== 'undefined') {
            bounds = _mapObject.customcircle.getBounds();
        } else {
            bounds = new google.maps.LatLngBounds(
                new google.maps.LatLng(
                    _settings.mapConfig.swBound.lat,
                    _settings.mapConfig.swBound.lng
                ),
                new google.maps.LatLng(
                    _settings.mapConfig.neBound.lat,
                    _settings.mapConfig.neBound.lng
                )
            );
        }

        if (_mapObject === null) {
            _mapObject = new google.maps.Map(document.getElementById(_settings.mapElementId),
                {
                    zoom: 4,
                    center: center
                });
        } else {
            _mapObject.setCenter(center);
            //_mapObject.fitBounds(bounds);
        }
        loadMarkers();

        //_mapObject.fitBounds(bounds);
    };

    var filterChanged = function (mapConfig) {
        if (typeof (mapConfig) !== 'undefined') {
            _settings.mapConfig = mapConfig;
        }
        if (_settings.filterPreventsMapMoveReload) {
            //google.maps.event.clearListeners(_mapObject, 'idle');
        }
        _settings.mapConfig.pageIndex = 0;
        _hideInfoWindow();
        initMap();
        mapMoved();
    };

    var filterCleared = function () {
        _hideInfoWindow(itemMarker);
        mapMoved();
        if (_settings.filterPreventsMapMoveReload) {
            //_mapObject.addListener('idle', mapMoved);
        }
    };

    var initFilter = function () {
        _filterConfig.filter.init(_mapObject, _filterConfig.filterSettings, filterChanged, filterCleared);
    };

    var loadMap = function (mapConfig) {
        _settings.mapConfig = mapConfig;

        initMap();
        if (typeof (_filterConfig.filter) !== 'undefined') {
            initFilter();
        }
        _mapObject.addListener('idle', function () {
            if (!_disableMapMoved) {
                mapMoved();
            }
            _disableMapMoved = false;
        });
    };

    var loadMapConfig = function (request) {
        let hostname = location.hostname.split('.');
        let areaCode = 'au';
        areaCode = hostname[hostname.length - 1];
        // init component
        $.ajax({
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            type: 'GET',
            url: _settings.mapConfigurationEndpoint + "?culture=" + areaCode,
            data: request,
            contentType: "application/json; charset=utf-8",
            success: loadMap
        });
    }

    var scriptLoadFailure = function (e) {
        alert('failed to load map scripts');
    }

    var init = function (settings, filterConfig) {
        _settings = settings;

        if (typeof (filterConfig) !== 'undefined') {
            _filterConfig = filterConfig;
        }

        LGFG.CP.MapsApiLoader.init(loadMapConfig, scriptLoadFailure);
    };

    return {
        init: init,
        mapObject: function () { return _mapObject; },
        reloadMap: loadMap,
        loadMapConfig: loadMapConfig,
    };
})();